import { create } from 'zustand'

import type { QueryStore } from '@models/Query'

import { initialState } from '../services/fetchKpi'
import type { FetchKpi } from '../types/FetchKpi'

export { useKpiStore }

const useKpiStore = () => {
  const query = useStore((state) => state.query)
  const storeQuery = useStore((state) => state.storeQuery)

  return { query, storeQuery }
}

const useStore = create<QueryStore<FetchKpi['query']>>((set) => ({
  query: initialState.query,
  storeQuery: (query) =>
    set((state) => ({ query: { ...state.query, ...query } })),
}))
